import { render, staticRenderFns } from "./grindingform.vue?vue&type=template&id=a8396914&"
import script from "./../ts/grindingform.ts?vue&type=script&lang=js&"
export * from "./../ts/grindingform.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports